// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';
import SpeechComponent from 'core/awspack/polly/SpeechComponent';

/**
 * @autodoc apply FsmAction
 */
class StopSpeechAction extends Action {

  static getTransitionLabel(transitionKey, actionConfig) {
    return 'On Speech Stopped';
  }

  enter(fsm) {
    const entity = fsm.getOwnerEntity();
    if (!entity.hasComponent('SpeechComponent')) {
      entity.setComponent(new SpeechComponent());
    }


    fsm.getWorld().loader.load(this.speech).then((speech) => {
      entity.speechComponent.addSpeech(speech);

      if (this.resetSpeech) {
        return speech.stop().then(() => {
          fsm.send(this.transitions.complete);
        }).catch((error) => {
          console.error(`[Sumerian] Could not stop speech: ${error}`);
        });
      } else {
        return speech.pause().then(() => {
          fsm.send(this.transitions.complete);
        }).catch((error) => {
          console.error(`[Sumerian] Could not pause speech: ${error}`);
        });
      }
    });
  }
}

StopSpeechAction.external = {
  key: 'StopSpeech',
  type: 'Speech',
  name: 'Stop Speech',
  description: 'Stops a playing speech file.',
  canTransition: true,
  parameters: [
    {
      name: 'Speech',
      key: 'speech',
      type: 'speech',
      description: 'Speech to stop.',
    },
    {
      name: 'Restart Speech',
      key: 'resetSpeech',
      type: 'boolean',
      description: 'Resets speech to beginning if checked.',
    },
  ],
  transitions: [
    {
      key: 'complete',
      description: 'State to transition to when the speech stops playing.',
    },
  ],
};

StopSpeechAction.register();

export default StopSpeechAction;
